module.exports = __webpack_public_path__ + "media/images/hero_images/about-1500-6674c9a0e8ef1c4847730f4bd2843a75.jpg";